/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Avatar,
  Stack,
  CardMedia,
  styled,
  Skeleton,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import profilecover from "src/assets/images/backgrounds/profilebg.jpg";
import userimg from "src/assets/images/profile/user-1.jpg";
import {
  IconDeviceMobile,
  IconFileDescription,
  IconPin,
  IconUserCircle,
} from "@tabler/icons";
// import ProfileTab from "src/components/apps/userprofile/profile/ProfileTab";
import BlankCard from "src/components/shared/BlankCard";

import ChildCard from "src/components/shared/ChildCard";
import { IconMail, IconMapPin } from "@tabler/icons";
import TopPerformerData from "src/components/dashboards/modern/TopPerformerData";
import DashboardCard from "src/components/shared/DashboardCard";

const DriverProfile = () => {
  const ProfileImage = styled(Box)(() => ({
    backgroundImage: "linear-gradient(#50b2fc,#f44c66)",
    borderRadius: "50%",
    width: "110px",
    height: "110px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
  }));
  const [isLoading, setLoading] = React.useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  // google map device use state
  const [deviceLocation, setDeviceLocation] = useState(null);

  useEffect(() => {
    // Get device location (dummy location for demonstration)
    setDeviceLocation({
      lat: 37.7749,
      lng: -122.4194,
    });
  }, []); // Empty dependency array to run the effect only once when the component mounts

  // Google Map configurations
  // const mapContainerStyle = {
  //   width: "100%",
  //   height: "300px",
  // };

  const performers = TopPerformerData;

  return (
    <>
      <BlankCard>
        {isLoading ? (
          <>
            <Skeleton
              variant="square"
              animation="wave"
              width="100%"
              height={330}
            ></Skeleton>
          </>
        ) : (
          <CardMedia
            component="img"
            image={profilecover}
            alt={profilecover}
            width="100%"
            height="100px"
          />
        )}
        <Grid container spacing={0} justifyContent="center" alignItems="center">
          {/* Post | Followers | Following */}
          <Grid
            item
            lg={4}
            sm={12}
            md={5}
            xs={12}
            sx={{
              order: {
                xs: "2",
                sm: "2",
                lg: "1",
              },
            }}
          >
            <Stack
              direction="row"
              textAlign="center"
              justifyContent="center"
              gap={6}
              m={2}
            >
              <Box>
                <Typography color="text.secondary">
                  <IconFileDescription width="20" />
                </Typography>
                <Typography variant="h4" fontWeight="600">
                  9
                </Typography>
                <Typography color="textSecondary" variant="h6" fontWeight={400}>
                  Total Vehicle
                </Typography>
              </Box>
              <Box>
                <Typography color="text.secondary">
                  <IconUserCircle width="20" />
                </Typography>
                <Typography variant="h4" fontWeight="600">
                  3,586
                </Typography>
                <Typography color="textSecondary" variant="h6" fontWeight={400}>
                  No Of Trips
                </Typography>
              </Box>
              {/* <Box>
                <Typography color="text.secondary">
                  <IconUserCircle width="20" />
                </Typography>
                <Typography variant="h4" fontWeight="600">
                  3,586
                </Typography>
                <Typography color="textSecondary" variant="h6" fontWeight={400}>
                  Counter 3
                </Typography>
              </Box> */}
            </Stack>
          </Grid>
          {/* about profile */}
          <Grid
            item
            lg={4}
            sm={12}
            xs={12}
            sx={{
              order: {
                xs: "1",
                sm: "1",
                lg: "2",
              },
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              textAlign="center"
              justifyContent="center"
              sx={{
                mt: "-85px",
              }}
            >
              <Box>
                <ProfileImage>
                  <Avatar
                    src={userimg}
                    alt={userimg}
                    sx={{
                      borderRadius: "50%",
                      width: "100px",
                      height: "100px",
                      border: "4px solid #fff",
                    }}
                  />
                </ProfileImage>
                <Box mt={1}>
                  <Typography fontWeight={600} variant="h5">
                    Mathew Anderson
                  </Typography>
                  <Typography
                    color="textSecondary"
                    variant="h6"
                    fontWeight={400}
                  >
                    Designer
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* <ProfileTab /> */}
      </BlankCard>

      <Grid item sm={12} lg={4} xs={12} mt={2}>
        <Grid container spacing={3}>
          <Grid item sm={4}>
            {/* <IntroCard /> */}
            <ChildCard>
              <Typography fontWeight={600} variant="h4" mb={2}>
                Driver Information
              </Typography>
              <Stack direction="row" gap={2} alignItems="center" mb={3}>
                <IconUserCircle size="21" />
                <Typography variant="h6" style={{ fontSize: "13px" }}>
                  Mr. Anil Kumar
                </Typography>
              </Stack>
              <Stack direction="row" gap={2} alignItems="center" mb={3}>
                <IconMail size="21" />
                <Typography variant="h6" style={{ fontSize: "13px" }}>
                  xyzanil@gmail.com
                </Typography>
              </Stack>
              <Stack direction="row" gap={2} alignItems="center" mb={3}>
                <IconDeviceMobile size="21" />
                <Typography variant="h6" style={{ fontSize: "13px" }}>
                  8897906789
                </Typography>
              </Stack>
              <Stack direction="row" gap={2} alignItems="center" mb={1}>
                <IconMapPin size="21" />
                <Typography variant="h6" style={{ fontSize: "13px" }}>
                  Kadru Overbridge, near laal hospital, kadru ranchi
                </Typography>
              </Stack>
              <Stack direction="row" gap={2} alignItems="center" mb={3}>
                <IconPin size="21" />
                <Typography variant="h6" style={{ fontSize: "13px" }}>
                  834003
                </Typography>
              </Stack>
            </ChildCard>
          </Grid>
          <Grid item sm={8}>
            {/* <PhotosCard /> */}

            <DashboardCard title="Last Trips Details">
              <TableContainer>
                <Table
                  aria-label="simple table"
                  sx={{
                    whiteSpace: "nowrap",
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Typography variant="subtitle2" fontWeight={600}>
                          Trip Name
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" fontWeight={600}>
                          Distance
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" fontWeight={600}>
                          Vehicle No
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" fontWeight={600}>
                          Date
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {performers.map((basic) => (
                      <TableRow key={basic.id}>
                        <TableCell>
                          <Stack direction="row" spacing={2}>
                            {/* <Avatar src={basic.imgsrc} alt={basic.imgsrc} sx={{ width: 40, height: 40 }} /> */}
                            <Box>
                              <Typography variant="subtitle2" fontWeight={600}>
                                Ranchi To Bokaro
                              </Typography>
                            </Box>
                          </Stack>
                        </TableCell>
                        <TableCell>
                          <Typography
                            color="textSecondary"
                            variant="subtitle2"
                            fontWeight={400}
                          >
                            200 km
                          </Typography>
                        </TableCell>
                        <TableCell>JH01AB1435</TableCell>
                        <TableCell>
                          <Typography variant="subtitle2">
                            02-01-2024
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </DashboardCard>
          </Grid>
        </Grid>
      </Grid>

      {/* <Grid item sm={12} lg={4} xs={12} mt={2}>
        <Grid container spacing={3}>
          <Grid item sm={12}>
            
              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                zoom={12}
                center={deviceLocation}
              >
                {deviceLocation && <Marker position={deviceLocation} />}
              </GoogleMap>
           
          </Grid>
        </Grid>
      </Grid> */}
    </>
  );
};

export default DriverProfile;
